// extracted by mini-css-extract-plugin
module.exports = {"singUpBtn":"Button_singUpBtn__m0TzF","moreDetails":"Button_moreDetails__2IXs2"};